var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsMoveTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5H10V7H21V19H3V5ZM4.5 6.5H8.5V8.5H19.5V17.5H4.5V6.5ZM7 11.5H12.5V9.5L16.5 13L12.5 16.5V14.5H7V11.5Z",
    fill: "#586C7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMoveTo);
export default __webpack_public_path__ + "static/media/icons_move_to.b2f587b1.svg";
export { ForwardRef as ReactComponent };